// extracted by mini-css-extract-plugin
export default {"headerBar":"vI-z","pointsSection":"wI-z","goToDashboard":"xI-z"};